import ProgressBarLabel from "~/components/ProgressBarLabel/ProgressBarLabel.jsx";
import ProgressBarInner from "~/components/ProgressBarInner/ProgressBarInner.jsx";
import useHandlers from "~/hooks/useHandlers";

import "./ProgressBar.css";

const ProgressBar = ({ selectedCapsules, data }) => {
  const { progressDiscount } = useHandlers({ selectedCapsules });

  const { totalItems, clonedDiscountTier: discountTier } = progressDiscount(data);

  return (
    <div className="progress-bar-container">
      <ProgressBarLabel totalItems={totalItems} discountTier={discountTier} />
      <ProgressBarInner totalItems={totalItems} discountTier={discountTier} />
    </div>
  );
};

export default ProgressBar;
